import React from 'react';
import Layout from '../../components/Layout';
import { Users, Hammer } from 'lucide-react';

export default function PersonalVigilancia() {
  return (
    <Layout>
      <div data-testid="vig-personal-page" className="space-y-6">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-lg bg-slate-900 flex items-center justify-center">
            <Users className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 font-['Manrope']">Personal</h1>
            <p className="text-slate-500 text-sm">Vigilancia</p>
          </div>
        </div>

        <div
          className="flex flex-col items-center justify-center text-center border border-dashed border-slate-300 rounded-xl py-20 bg-slate-50"
          data-testid="vig-personal-construction"
        >
          <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mb-4">
            <Hammer className="w-8 h-8 text-amber-600" />
          </div>
          <p className="text-lg font-medium text-slate-700">Próximamente</p>
          <p className="text-sm text-slate-500 mt-1">El control de vales de salida de personal llegará en una fase posterior.</p>
        </div>
      </div>
    </Layout>
  );
}
